import { ChangeDetectionStrategy, Component, DestroyRef, effect, inject, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Guid, SM, VzTag, VzTagOptions } from '@models';
import { CacheService } from '@services/cache.service';
import { BaseCmp } from '@base/base-cmp';

interface VisTag {
    id: string;
    text?: string;
    icon?: string;
    desc?: string;
    color: string;
}

@Component({
    selector: 'vz-tag, [vz-tag]',
    templateUrl: './tag.component.html',
    styleUrls: ['./tag.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule]
})
export class TagComponent extends BaseCmp {

    tag             = input<VzTag>();
    tagId           = input<Guid>();
    tagSize         = input<'small' | 'default' | 'large'>('default');

    visTags         = signal<VisTag[] | undefined>(undefined);
    watchParents    = signal<SM<VzTag> | undefined>(undefined);

    readonly _cache         = inject(CacheService);
    readonly _destroyRef    = inject(DestroyRef);

    constructor() {
        super();
        effect(() => this.update(this.tagId(), this.tag()));
    }

    update(tagId: Guid | undefined, tag: VzTag | undefined): void {
        if (tag) {
            const tags: VisTag[] = [];
            const res = this.addParents(tag, tags, (tag.parents || []).reduce((obj, t) => ({ ...obj, [t.id!]: t }), {}));
            if (!res) {
                tags.unshift({ id: 'N/A', color: '#fbb', text: '?' });
            }
            this.visTags.set(tags);
        }
        else if (tagId) {
            this.__Uall();
            this._S.tag = this._cache.watch('tag', tagId).subscribe(st => {
                // console.log('=[TagComponent]===> update, _dc.watchItem:', st);
                if (st?.item) {
                    // if (st.item.parents) { // TODO watch for linked objects
                    //     this._dc.setWatchItemLinks('tag', tagId, st.item.parents.map(t => t.id!));
                    // }
                    const tags: VisTag[] = [];
                    const res = this.addParents(st.item, tags, (st.item.parents || []).reduce((obj, t) => ({ ...obj, [t.id!]: t }), {}));
                    if (!res) {
                        tags.unshift({ id: 'N/A', color: '#fbb', text: '?' });
                    }
                    this.visTags.set(tags);
                }
                else {
                    this.visTags.set([{ id: tagId, color: '#ccc', text: '…' }]);
                }
            });
        }
        else {
            this.visTags.set([{ id: 'N/A', color: '#ccc', text: '?' }]);
        }
    }

    addParents(tag: VzTag, tags: VisTag[], items: SM<VzTag>): boolean {
        if (tags.length > 0 && tag.options & VzTagOptions.HideTagParent) {
            return true;
        }
        const pt: VisTag = { id: tag.id!, color: tag.color || '#ccc', desc: tag.description };
        if (
            (tags.length > 0 && !(tag.options & VzTagOptions.HideTextParent))
            || (tags.length == 0 && !(tag.options & VzTagOptions.HideText))
        ) {
            pt.text = tag.text;
        }
        if (
            (tags.length > 0 && !(tag.options & VzTagOptions.HideIconParent))
            || (tags.length == 0 && !(tag.options & VzTagOptions.HideIcon))
        ) {
            pt.icon = tag.icon;
        }
        tags.unshift(pt);
        if (tag.parentId) {
            const ptag = items[tag.parentId];
            if (ptag) {
                return this.addParents(ptag, tags, items);
            }
            else {
                return false;
            }
        }
        return true;
    }

}

